export default "__VITE_ASSET__ByMD2p$g__"